import { IconName } from '@wegroup/design-system';
import { useQuery, UseQueryResult } from 'react-query';
import { wgApi } from '../../../app/src/features/api/wgApi';
import { PartyLegalForm } from '../types/conversation';

export interface FlowItem {
  id: string;
  name: string;
  title: string;
  // TBD BY BACKEND
  description?: string;
  is_legal_only?: boolean;
  icon_key?: IconName;
  party_type?: PartyLegalForm;
  // ---
  companies?: string[];
  type: FlowType;
  sub_type?: FlowSubType;
  country_code?: string;
  supported_countries?: string[];
  supported_languages?: string[];
  subjects?: string[];
  previous?: string;
  next?: string;
  tags?: string[];
}

export type FlowType =
  | 'lead'
  | 'quote'
  | 'offer'
  | 'contract'
  | 'risk_analysis'
  | 'company_scan';

export type FlowSubType =
  | 'ADVISORY'
  | 'ALLCOVER_TWOWHEELER'
  | 'ANVA'
  | 'BALOISE'
  | 'DNA_YACHT'
  | 'EUROMEX'
  | 'PIA'
  | 'RISK_ANALYSIS_SHORT'
  | 'VILLASURE';

interface Params {
  country_codes?: string[];
  lang?: string;
  language?: string;
  types?: FlowType;
}

interface Response {
  items: FlowItem[];
}

export const getAllFlows = async (params?: Params): Promise<Response> => {
  // const path = `/v1/api/flows`;
  /** This api checks distribution persmissions to show or hide flows */
  const path = `/v1/api/distributions/me/flows`;
  const { data, isError } = await wgApi.get<Response>(path, {
    query: { ...params },
  });
  if (isError) throw new Error();
  return data;
};

export const getUseAllFlowsQKey = (params?: Params) => ['all-flows', params];

export const useAllFlows = (params?: Params): UseQueryResult<Response> => {
  return useQuery<Response>(
    getUseAllFlowsQKey(params),
    () => getAllFlows(params),
    {
      refetchOnWindowFocus: false,
    },
  );
};
